import styled from "styled-components";
import { Heading, ButtonSettings, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const LandingPageStyled = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
`;

export const HeadingStyled = styled(Heading)`
  width: 100%;
  font-weight: normal;
`;

export const TextStyled = styled(Text)`
  width: 100%;
  font-weight: normal;
  margin-bottom: ${props => props.theme.spacing.large};
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
`;

export const StepText = styled(Text)`
  vertical-align: middle;
  font-weight: normal;
  display: inline-block;
  margin-bottom: ${props => props.theme.spacing.small};
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  ${props => props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT && `width: 85%`};
  width: 80%;
`;

export const LinkStyled = styled.span`
  border: 2px solid rgba(${props => props.theme.color.primaryRGB}, 0.4);
  border-radius: 8px;
  font-size: ${props => props.theme.font.size.default};
  font-weight: ${props => props.theme.font.weight.bold};
  padding: ${props => props.theme.spacing.small};
  color: ${props => props.theme.color.white};
  display: inline-block;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: calc(${props =>
  props.theme.font.size.xlarge} + ${props =>
  props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "4rem" : "2rem"});
`;

export const PinContainerStyled = styled.div`
width: 70%;
margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.spacing.medium};
  direction: ltr;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: calc(${props =>
  props.theme.font.size.xlarge} + 2rem);
`;

export const PinItemStyled = styled.span`
  border: 2px solid rgba(${props => props.theme.color.primaryRGB}, 0.4);
  border-radius: 8px;
  font-size: ${props => props.theme.font.size.xlarge};
  font-weight: ${props => props.theme.font.weight.bold};
  color: ${props => props.theme.color.white};
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 9.15rem;
  width: ${props => (props.userLocale === "fr" ? "7.5rem" : "9.15rem")};
  height: 6.65rem;
  ${props => props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT && `margin-left: .8rem`}
  margin-${props => (props.userLocale === "fr" ? "left: .5rem" : "left: .8rem")};

`;

export const LandingContainerStyled = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  display: block;
  margin-top: ${props => props.theme.spacing.xsmall};
  width: 38%;
  margin: 0 auto;
`;

// export const LogoStyled = styled(Logo)`
export const LogoStyled = styled.div`
  // display: inline-block;
  // width: unset;
  // height: 3.5vw;
  position: absolute;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
    props.theme.spacing.large}
`;

export const LineTextStyled = styled.h1`
  overflow: hidden;
  text-align: center;
  color: ${props => props.theme.color.white};
  font-weight: ${props => props.theme.font.weight.regular};
  width: calc(100% - 100px);
  margin: 0 auto;
  margin-bottom: ${props => props.theme.spacing.small};
  &:before,
  &:after {
    background-color: ${props => props.theme.color.greyLight};
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 50%;
    // border: 1px solid ${props => props.theme.color.greyLight};
  }

  &:before {
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: 0.5em;
    margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: -50%;
  }

  &:after {
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 0.5em;
    margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: -50%;
  }

`;

export const SecondaryLogoStyled = styled.img`
  vertical-align: middle;
  & + & {
    margin: 0 15px;
  }
`;

export const LeftBlock = styled.div`
  display: flex;
  width: 60%;
  padding-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right : 5.5rem" : "left : 5.5rem")}
  padding-top: ${props => props.theme.spacing.xlarge};
  flex: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT || props.userLocale === "fr" ? "8" : "5")};
`;

export const RightBlock = styled.div`
  display: flex;
  width: 40%;
  padding-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.spacing.large};
  padding-top: ${props => props.theme.spacing.large};
  flex: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT || props.userLocale === "fr" ? "3" : "5")};
`;

export const AlignText = styled.div`
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")};
`;

export const StepContainer = styled.span`
  vertical-align: middle;
  padding-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.font.size.small};
  width: 100%;
  margin-bottom: ${props => props.theme.spacing.xmedium};
`;

export const StepNumber = styled.div`
  border-radius: 50%;
  display: inline-block;
  width: calc(${props => props.theme.spacing.xlarge});
  height: calc(${props => props.theme.spacing.xlarge});
  padding: ${props => props.theme.spacing.default} ${props => props.theme.spacing.xsmall};
  border: 3px solid rgba(${props => props.theme.color.primaryRGB}, 0.4);
  color: ${props => props.theme.color.white};
  text-align: center;
  font-size: ${props => props.theme.font.size.large};
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.font.size.medium};
`;

export const StepTextContainer = styled.span`
  vertical-align: middle;
  display: inline;
`;

export const QRCodeWrapper = styled.div`
  width: 25vw;
  height: 25vw;
  border: 1.25rem solid #fff;
  border-radius: ${props => props.theme.spacing.small};
  position: absolute;
  top: calc(${props => props.theme.spacing.xlarge} * 3);
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left: 7.3rem" : "right: 9.3rem")};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const PinLoginInfoContainer = styled.div`
  display: flex;
`;
export const LoginOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
